import React from "react";
import { FavoriteToggle } from "./FavoriteToggle";
import { LiveboardList } from "./LiveboardList";
import { CollapseButton, AddLiveboardButton } from "./SidebarButton";
import { CreateLiveboardDialog } from "./CreateLiveboardDialog";
import clsx from "clsx";
import { CreateLiveboardButton } from "./CreateLiveboardButton";
import { useSidebarExpansion } from "./hooks/useSidebarExpansion";
import { useSidebarFavorites } from "./hooks/useSidebarFavorites";
import { useUserPrivileges } from "@/hooks/useUserPrivileges";
import { useAuth } from "@/Auth";

export function Sidebar() {
  const { isSidebarExpanded, toggleExpansion } = useSidebarExpansion({
    collapseSidebarOnBreakpoint: 912,
  });
  const { isShowingFavoritesOnly, toggleFavorites } = useSidebarFavorites();
  const [isAddLiveboardDialogOpen, setIsAddLiveboardDialogOpen] = React.useState(false);
  const { search_data: hasSearchDataPrivilege } = useUserPrivileges();
  const isDemo = useAuth().user?.is_demo ?? false;

  function style(s: Partial<{ expanded: string; collapsed: string; default: string }>): string {
    return clsx(s.default, isSidebarExpanded ? s.expanded : s.collapsed);
  }

  return (
    <>
      <aside
        className={style({
          default: "relative pt-4 pl-6 mr-4 flex flex-col h-full gap-4 transition-all duration-150",
          expanded: "w-[272px]",
          collapsed: "w-[68px]",
        })}
      >
        <div className="absolute top-[50%] -right-6 z-10 flex flex-col gap-2">
          <FavoriteToggle
            showFavoritesOnly={isShowingFavoritesOnly}
            toggleFavorites={toggleFavorites}
          />
          <CollapseButton isExpanded={isSidebarExpanded} onClick={toggleExpansion} />
          {hasSearchDataPrivilege && !isDemo && (
            <AddLiveboardButton onClick={() => setIsAddLiveboardDialogOpen(true)} />
          )}
        </div>
        <nav
          className={clsx(
            "sidebar-content-container flex flex-col gap-3 grow text-sm",
            isSidebarExpanded ? "overflow-y-auto overflow-x-hidden" : "overflow-y-visible",
          )}
        >
          <LiveboardList
            favoritesOnly={isShowingFavoritesOnly}
            isSidebarExpanded={isSidebarExpanded}
          />
          {hasSearchDataPrivilege && !isDemo && (
            <CreateLiveboardButton
              isExpanded={isSidebarExpanded}
              onClick={() => setIsAddLiveboardDialogOpen(true)}
            />
          )}
        </nav>
      </aside>
      {hasSearchDataPrivilege && !isDemo && (
        <CreateLiveboardDialog
          show={isAddLiveboardDialogOpen}
          onClose={() => setIsAddLiveboardDialogOpen(false)}
        />
      )}
    </>
  );
}
